import DataFlow from './dataFlow';
import StoreCreator from './storeCreator';

export type { AnyAction, IActions, IDispatch, IReducer, IReducers, IState, Saga0 } from './interface';
export { default as dispatch } from './dispatch';
export { default as connect } from './connect';

export const createStore = StoreCreator.create;
export const initDataFlow = DataFlow.init;
